<template>
    <!--scrollable list-->
    <div class="scroll list-wrapper p-2 h-100" style="min-height: 500px; background-color: #282D69;">
        <ul>
            <li>
                <div class="d-flex justify-content-between" style="border-bottom: 1px solid white;">
                    <div class="d-flex flex-column justify-content-end">
                        <h4 class="mb-0 pb-3">Modules</h4>
                    </div>
                </div>
            </li>
            <li class="text-center m-2" v-if="courseDetails.chapters.length < 1">
                No modules yet
            </li>
            <li>
                <button v-if="editEnabled" type="button" v-on:click="$emit('handleAddChapter')" class="btn-add-module mt-1 mb-1">
                    <i class="fa fa-plus mr-2"></i>
                    <span>Add module</span>
                </button>
            </li>
            <li v-for="(chapter, idx) in courseDetails.chapters" class="curriculum m-1 item-title" v-bind:class="{ active: (selectedChapter == idx) }">

                <div class="d-flex align-items-center" v-on:click="$emit('handleToggle', $event, idx)"
                     draggable
                     @dragstart="$emit('handleDrag', $event, chapter)"
                     @drop="$emit('handleDrop', $event, chapter)"
                     @dragover.prevent
                     @dragenter.prevent>
                    <i class="fa fa-bars mr-2 ml-2"></i>
                    <div v-if="editEnabled" class="container d-flex justify-content-between align-items-center pl-0">
                        <input @blur="$emit('handleInputLeave', $event)" type="text" name="chapter-name" v-model="chapter.name" placeholder="New Module" class="chapter-input" :id="'ch-'+idx" readonly v-bind:class="{bdRed: chapter.name === ''}" />
                        <i v-on:click="$emit('handleInputEnter', $event, idx, null)" class="fa fa-pencil"></i>
                        <i v-on:click="$emit('handleDeleteItem', 'chapter', {courseDetails, chapter})" class="fa fa-trash ml-3"></i>
                    </div>
                    <span v-else class="inner-module text-wrap">{{ idx + 1 }}. {{ chapter.name }}</span>
                </div>

                <ul class="pages" v-show="selectedChapter == idx">
                    <li>
                        <div class="d-flex justify-content-between pt-2 pr-1 mb-1" style="border-bottom: 1px solid white;">
                            <div class="d-flex flex-column justify-content-end">
                                <h4 class="mb-1">Pages</h4>
                            </div>
                            <div class="d-flex mr-2">
                                <button v-if="editEnabled" type="button" v-on:click="$emit('handleAddPage', chapter)" class="btn-add-page pl-3 pr-3 pt-1" style="border-bottom: none;">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                    <li v-show="chapter.pages.length < 1">
                        No pages yet
                    </li>
                    <li v-for="(page, pageIdx) in chapter.pages"
                        v-on:click="$emit('changePage', pageIdx)" class="curriculum" v-bind:class="{ activePage: (selectedPage == pageIdx) }">

                        <div class="d-flex align-items-center item-title"
                             draggable
                             @dragstart="$emit('handleDrag', $event, chapter)"
                             @drop="$emit('handleDrop', $event, chapter)"
                             @dragover.prevent
                             @dragenter.prevent>
                            <i class="fa fa-bars mr-2 ml-2"></i>
                            <div v-if="editEnabled" class="container d-flex justify-content-between align-items-center pl-0">
                                <input @blur="$emit('handleInputLeave', $event)" v-show="editEnabled" type="text" name="page-name" v-model="page.name" placeholder="New Page" readonly class="page-input" v-bind:class="{bdRed: page.name === ''}" :id="'ch-'+ idx +'p-' + pageIdx" />
                                <i v-on:click="$emit('handleInputEnter', $event, idx, pageIdx)" class="fa fa-pencil"></i>
                                <i v-on:click="$emit('handleDeleteItem','page', {chapter, page})" class="fa fa-trash ml-3"></i>
                            </div>
                            <span v-else class="inner">{{idx + 1}}.{{ pageIdx + 1 }}. {{ page.name }}</span>
                        </div>

                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'SideMenu',
        props: ["initialCourseDetails", "edit", "tab", "chapter", "page"],
        data: function () {
            return {
                courseDetails: this.initialCourseDetails,
                editEnabled: this.edit,
                selectedTab: this.tab,
                selectedChapter: this.chapter,
                selectedPage: this.page,
            };
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            chapter: function (newVal, oldVal) {
                this.selectedChapter = newVal;
            },
            page: function (newVal, oldVal) {
                this.selectedPage = newVal;
            },
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;
            },

        },
        methods: {
            clicked(tabIndex, page, chapter) {
                this.selectedTab = tabIndex;
                this.$emit("tabClick", tabIndex, page, chapter);
            },
        },
        mounted: function () {
            //console.log("Side menu loaded", this.courseDetails, this.editEnabled, this.selectedTab);
        },
    }
</script>

<style scoped>
    .pages{
        border-left: 1px solid white;
        padding-left: 10px;
        margin-top: 10px;
        margin-left: 15px;
    }

    .btn-add-module {
        width: 100%;
        background-color: white;
        color: #42C1C4;
    }

</style>

